import { forwardRef, useState } from 'react';
import Button from '@/components/Button';
import { withLoading, withMinimumDelay } from '@/utils/async';
import { useForm } from 'react-hook-form';

export interface NotificationFormData {
  supplier: { email: string };
}

interface NotificationFormProps {
  supplierEmail?: string;
  onSubmit: (data: NotificationFormData) => Promise<void>;
}

const NotificationForm = forwardRef<HTMLFormElement, NotificationFormProps>(
  function NotificationForm({ supplierEmail, onSubmit }, ref) {
    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm<NotificationFormData>({
      defaultValues: {
        supplier: {
          email: supplierEmail ?? '',
        },
      },
    });

    const [loading, setLoading] = useState(false);
    const handleSubmitWithLoading = withLoading(withMinimumDelay(onSubmit, 500), setLoading);

    return (
      <form ref={ref} onSubmit={handleSubmit(handleSubmitWithLoading)}>
        <div className="grid grid-cols-2 gap-4 lg:gap-8">
          <div className="col-span-2">
            <label htmlFor="supplierOrderEmail" className="block font-medium text-gray-700">
              Order Email:
            </label>

            <input
              id="supplierOrderEmail"
              {...register('supplier.email', {
                required: false,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address',
                },
              })}
              className="mt-1 p-2 border border-gray-300 rounded-md w-full"
            />
            <p className="text-sm text-gray-500 mt-1">
              Orders from customers will be sent to this email.
            </p>
            {errors.supplier?.email && (
              <p className="text-red-700 text-sm mt-1">{errors.supplier.email.message}</p>
            )}
          </div>
        </div>

        <div className="mt-4 flex justify-end">
          <Button type="submit" variant="primary" loading={loading}>
            Save
          </Button>
        </div>
      </form>
    );
  },
);

export default NotificationForm;
